import React, { useEffect, useState } from 'react';
import { Titled } from 'react-titled';
import { useTranslation } from 'react-i18next';
import AppLayout from 'components/common/AppLayout';
import CompanyInfoForm, {
  CompanyInfoValues,
} from 'components/SignUp/CompanyInfo/CompanyInfoForm';
import CompanyInfoJoinExisting from 'components/SignUp/CompanyInfo/CompanyInfoJoinExisting';
import NoticeLayoutRedesign from 'components/common/NoticeLayoutRedesign';
import NoticeLayoutFooter from 'components/common/NoticeLayoutFooter';
import { useAuth0 } from '@auth0/auth0-react';
import useReturnToUrl from 'hooks/useReturnToUrl';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { PRO_PORTAL_URL } from 'config';

const CompanyInfo = () => {
  const { t } = useTranslation();
  const user = useCurrentUser();
  const [formValues, setFormValues] = useState({} as CompanyInfoValues);
  const [partnerAccountMatch, setPartnerAccountMatch] = useState<Array<any>>();

  const contactEmail = user?.contactEmail || '';
  const showInfoForm = !partnerAccountMatch;

  // Custom footer block for this page only, using Auth0 login redirect
  const { loginWithRedirect } = useAuth0();
  const { SignInURL } = useReturnToUrl();
  const handleSignIn = () => {
    loginWithRedirect({
      prompt: 'login',
      appState: { returnTo: SignInURL() },
    });
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const customFooterBlocks = (_existingBlocks: React.ReactNode[]) => [
    <NoticeLayoutFooter.NavLink
      key='back-to-sign-in'
      onClick={handleSignIn}
      style={{ cursor: 'pointer' }}>
      {t('signUp.backToSignIn')}
    </NoticeLayoutFooter.NavLink>,
  ];

  useEffect(() => {
    const cameFrom = localStorage.getItem('cameFrom');
    if (cameFrom === 'proPortal') {
      window.location.href = PRO_PORTAL_URL;
    }

    localStorage.removeItem('cameFrom');
  }, []);

  return (
    <Titled title={title => `${t('signUp.companyInfo.header')} - ${title}`}>
      <AppLayout
        showHeader={false}
        showLeftNav={false}
        showGreyPanel={true}
        showFooter={false}>
        <NoticeLayoutRedesign
          title={
            showInfoForm || partnerAccountMatch?.length === 0
              ? t('signUp.companyInfo.header')
              : t('signUp.companyInfo.joinExisting.header')
          }
          showFooter={true}
          customFooterBlocks={customFooterBlocks}>
          <>
            {showInfoForm && (
              <CompanyInfoForm
                email={contactEmail}
                setFormValues={setFormValues}
                setPartnerAccountMatch={setPartnerAccountMatch}
              />
            )}
            {!showInfoForm && (
              <CompanyInfoJoinExisting
                email={contactEmail}
                formValues={formValues}
                partnerAccountMatch={partnerAccountMatch}
              />
            )}
          </>
        </NoticeLayoutRedesign>
      </AppLayout>
    </Titled>
  );
};

export default CompanyInfo;
